import axios from "services/axios";
import {useMutation, useQueryClient} from "react-query";

import {QUERY} from "./useQueryReview";

export function useAddReview(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(values => axios.post("/reviews", values).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
		},
	});
}
export function useEditReview(id, options = {}) {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.put(`/reviews/${id}`, formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
		},
	});
}

export function useDeleteReview(options = {}) {
	const queryClient = useQueryClient();

	return useMutation(formData => axios.delete(`/reviews/${formData.id}`, formData).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
		},
	});
}

export function useSendLinkReview(id) {
	return useMutation(values => axios.post(`/reviews/${id}/send-link`, values).then(res => res.data), {});
}
